import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/layout';
import Orders from './orders/Orders';
import CreateOrders from './orders/CreateOrders';
import OrderDetails from './orders/OrderDetails';
import Home from './Home';
import Customers from './customers/Customers';
import Customer from './customers/Customer';
import CreateCustomers from './customers/CreateCustomers';
import UpdateCustomers from './customers/UpdateCustomers';
import Materials from './Materials';
import Login from './Login';
import AddUser from './AddUser';
import Projects from './Projects';
import Receivers from './Receivers';
import Shippers from './Shippers';
import Users from './Users';
import BOLs from './bols/BOLs';
import BOLDetails from './bols/BOLDetails';
import CreateBOL from './bols/CreateBOL';
import CompleteBOL from './bols/CompleteBOL';
import TruckWeighInReport from './bols/TruckWeighInReport';
import RailcarUnloads from './bols/RailcarUnloads';
import Railcars from './railcars/Railcars';
import RailcarUpload from './railcars/RailcarUpload';
import GroundInventory from './ground-inventory/GroundInventory';
import Profile from './Profile';
import CustomerHelp from './CustomerHelp';
import { getStoredUser, getToken } from './auth';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  const token = getToken();
  const user = getStoredUser();
  const isAuthenticated = Boolean(token && user);
  const routeKey = `${location.pathname}${location.search}`;
  const protectedElement = (element) => (isAuthenticated ? element : <Navigate to="/login" replace />);

  return (
    <Layout>
      <Routes key={routeKey}>
        <Route path="/" element={<Navigate to={isAuthenticated ? '/home' : '/login'} replace />} />
        <Route path="/home" element={protectedElement(<Home />)} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <Login />} />
        <Route path="/AddUser" element={protectedElement(<AddUser />)} />
        <Route path="/orders" element={protectedElement(<Orders />)} />
        <Route path="/orders/:id" element={protectedElement(<OrderDetails />)} />
        <Route path="/orders/create" element={protectedElement(<CreateOrders />)} />
        <Route path="/customers" element={protectedElement(<Customers />)} />
        <Route path="/customers/Customer/:id" element={protectedElement(<Customer />)} />
        <Route path="/customers/Create" element={protectedElement(<CreateCustomers />)} />
        <Route path="/customers/Update/:id" element={protectedElement(<UpdateCustomers />)} />
        <Route path="/materials" element={protectedElement(<Materials />)} />
        <Route path="/projects" element={protectedElement(<Projects />)} />
        <Route path="/receivers" element={protectedElement(<Receivers />)} />
        <Route path="/shippers" element={protectedElement(<Shippers />)} />
        <Route path="/users" element={protectedElement(<Users />)} />
        <Route path="/bols" element={protectedElement(<BOLs />)} />
        <Route path="/bols/reports/truck-weigh-ins" element={protectedElement(<TruckWeighInReport />)} />
        <Route path="/bols/create" element={protectedElement(<CreateBOL />)} />
        <Route path="/bols/complete/:id" element={protectedElement(<CompleteBOL />)} />
        <Route path="/bols/:id" element={protectedElement(<BOLDetails />)} />
        <Route path="/railcars" element={protectedElement(<Railcars />)} />
        <Route path="/railcars/upload" element={protectedElement(<RailcarUpload />)} />
        <Route path="/railcars/unloads" element={protectedElement(<RailcarUnloads />)} />
        <Route path="/ground-inventory" element={protectedElement(<GroundInventory />)} />
        <Route path="/profile" element={protectedElement(<Profile />)} />
        <Route path="/help" element={protectedElement(<CustomerHelp />)} />
        <Route path="*" element={<Navigate to={isAuthenticated ? '/home' : '/login'} replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
